import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { APP_DEFAULT_PATH } from 'config';

export default function SuperAdminProtectedRoutes({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user || user.role !== 'super-admin') {
    // Redirect non-super-admins to default app path
    return <Navigate to={APP_DEFAULT_PATH} state={{ from: location }} replace />;
  }
  return children;
}

SuperAdminProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired
};
